/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_SponsoredInputs */

const en_directory_home_sponsored = /** @type {(inputs: Directory_Home_SponsoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsored`)
};

const zh_directory_home_sponsored = /** @type {(inputs: Directory_Home_SponsoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助推广`)
};

/**
* | output |
* | --- |
* | "Sponsored" |
*
* @param {Directory_Home_SponsoredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_sponsored = /** @type {((inputs?: Directory_Home_SponsoredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_SponsoredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_sponsored(inputs)
	return zh_directory_home_sponsored(inputs)
});
export { directory_home_sponsored as "directory.home.sponsored" }